import { getItem } from '@/modules/inventory/services';
import type { LogisticsOrderInput } from '@/modules/logistics/types';

export async function validateLogisticsOrderInput(
  input: LogisticsOrderInput,
): Promise<string | null> {
  if (!input.scheduledDate.trim()) {
    return 'La fecha programada es obligatoria.';
  }
  if (input.inventoryItemIds.length === 0) {
    return 'Seleccioná al menos un artículo.';
  }
  for (const itemId of input.inventoryItemIds) {
    const item = await getItem(itemId);
    if (!item) return `Artículo no encontrado: ${itemId}.`;
  }
  return null;
}
